 /**
     * Take to shooping cart
     */
  $('.btn:not(.cta)').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
    }, 1000);
});